import rateCategoriesService from 'api/ratescategories/rateCategoriesService';
import Feature from 'Services/Feature';
const feedRateCategoryPayload = (rateCategory, rateCategoriesMetadata) => {
    const payload = {
        label: rateCategory.label,
        includes_taxes: rateCategory.includes_taxes,
        currency: rateCategory.currency || null,
        tax_id: rateCategory.tax_id || null,
        default_layouts: {
            estimates: rateCategory.default_layouts.estimates.id || null,
            invoices: rateCategory.default_layouts.invoices.id || null,
            credit_notes: rateCategory.default_layouts.credit_notes.id || null,
            models: rateCategory.default_layouts.models.id || null,
            deliveries: rateCategory.default_layouts.deliveries.id || null,
            orders: rateCategory.default_layouts.orders.id || null,
            proformas: rateCategory.default_layouts.proformas.id || null,
        },
    };
    if (rateCategory.price.type === 'value') {
        payload.price = {
            type: rateCategory.price.type,
        };
    } else {
        payload.price = {
            type: rateCategory.price.type,
            value: rateCategory.price.value,
        };
    }
    if (rateCategoriesMetadata.accounting.enabled) {
        payload.accounting_code_id = rateCategory.accounting.accounting_code_id || null;

        if (rateCategoriesMetadata.accounting.use_specific_code_for_discount) {
            payload.discount_accounting_code_id =
                rateCategory.accounting.discount_accounting_code_id || null;
        }
    }

    return payload;
};
export default {
    namespaced: true,
    state() {
        return {
            rateCategories: [],
            rateCategoriesMetadata: {},
        };
    },
    getters: {
        rateCategories: (state) => state.rateCategories,
        rateCategoriesMetadata: (state) => state.rateCategoriesMetadata,
    },
    mutations: {
        setRateCategories(state, payload) {
            state.rateCategories = payload;
        },
        setRateCategoriesMetadata(state, payload) {
            state.rateCategoriesMetadata = payload;
        },
    },
    actions: {
        fetchRateCategories({ commit }) {
            return new Promise((resolve, reject) => {
                rateCategoriesService
                    .getAllRateCategories()
                    .then((response) => {
                        commit('setRateCategories', response);
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        updateRateCategory({ commit, getters, dispatch }, rateCategory) {
            return new Promise((resolve, reject) => {
                rateCategoriesService
                    .updateRateCategory(
                        feedRateCategoryPayload(rateCategory, getters.rateCategoriesMetadata),
                        rateCategory.id,
                    )
                    .then((response) => {
                        const rateCategories = getters.rateCategories.map((category) =>
                            category.id === response.id ? response : category,
                        );
                        commit('setRateCategories', rateCategories);

                        if (Feature.isEnabled('einvoicing-vat-parameters')) {
                            dispatch('vatStore/fetchTaxes', '', {
                                root: true,
                            });
                        }

                        resolve();
                    })
                    .catch((err) => {
                        reject();
                    });
            });
        },
        postRateCategory({ commit, getters }, rateCategory) {
            return new Promise((resolve, reject) => {
                rateCategoriesService
                    .postRateCategory(
                        feedRateCategoryPayload(rateCategory, getters.rateCategoriesMetadata),
                    )
                    .then((response) => {
                        commit('setRateCategories', [...getters.rateCategories, response]);
                        resolve();
                    })
                    .catch((err) => reject());
            });
        },

        deleteRateCategory({ commit, getters }, id) {
            return new Promise((resolve, reject) => {
                rateCategoriesService
                    .deleteRateCategory(id)
                    .then((response) => {
                        commit('setRateCategories', [
                            ...getters.rateCategories.filter((item) => item.id !== id),
                        ]);
                        resolve(response);
                    })
                    .catch((err) => reject());
            });
        },

        fetchRateCategoriesMetadata({ commit }) {
            return new Promise((resolve, reject) => {
                rateCategoriesService
                    .getRateCategoriesMetadata()
                    .then((response) => {
                        commit('setRateCategoriesMetadata', response);
                        resolve();
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
